const EPSILON = 1e-9;

const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : null;
};

const isEffectivelyInteger = (n) => Math.abs(n - Math.round(n)) < EPSILON;

export const formatNumberEsCL = (value, { minimumFractionDigits = 0, maximumFractionDigits = 0 } = {}) => {
  const n = toNumber(value);
  if (n === null) return '—';
  return n.toLocaleString('es-CL', { minimumFractionDigits, maximumFractionDigits });
};

/**
 * Formato moneda CLP simple ($).
 * - Si el número es entero -> sin decimales.
 * - Si trae decimales -> 2 decimales.
 */
export const formatMoneyCLP = (value) => {
  const n = toNumber(value);
  if (n === null) return '$ 0';
  const isInt = isEffectivelyInteger(n);
  const decimals = isInt ? 0 : 2;
  return `$ ${n.toLocaleString('es-CL', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
};

/**
 * Formato "MM$" usado por el dashboard (histórico).
 * - Si el número es entero -> sin decimales.
 * - Si trae decimales -> 2 decimales.
 */
export const formatMoneyMM = (value) => {
  const n = toNumber(value);
  if (n === null) return 'MM$ 0';
  const isInt = isEffectivelyInteger(n);
  const decimals = isInt ? 0 : 2;
  return `MM$ ${n.toLocaleString('es-CL', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
};

export const formatPercent = (ratio, { maximumFractionDigits = 1 } = {}) => {
  const n = toNumber(ratio);
  if (n === null) return '—';
  const pct = n * 100;
  return `${pct.toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits })}%`;
};

